module.exports = __webpack_public_path__ + "assets/img/qrCode2.d0e57d13.png";